import moment from 'moment-timezone';
import {error} from '.';
import {indicatorMetaBase} from '../config/environment.js';
import {fetchJson} from '../utils/fetch_utils';
import * as ActionTypes from './actionTypes';

export const updateIndicatorTimesAsyncPromise = (indicator, validTimes, onComplete) => {
  const now = new Date().toISOString();
  const sydneyTz = moment.tz('Australia/Sydney').format('Z');

  return dispatch => {
    if (indicator.metaLink !== undefined && indicator.metaLink !== null) {
      fetchJson(indicatorMetaBase + indicator.metaLink + '?time=' + now)
      .then(data => {
        if (indicator.fix_afdrs_metadata_time) {
          // Some AFDRS times say they are Zulu, but they are not. They are Sydney time.
          data.timeArray = data.timeArray.map(t => t.replace('Z', sydneyTz));
          data.creationTime = data.creationTime.replace('Z', sydneyTz);
        }

        dispatch(
          _updateIndicatorTimes(indicator.prefix,
            data.timeArray,
            data.creationTime,
            data.importTime,
            data.source,
            data.timeless,
            validTimes)
        );
        if (onComplete) {
          onComplete();
        }
      })
      .catch(err => {
        dispatch(error(`Failed to load times for ${indicator.prefix}: ${err.message || err}`));
        if (onComplete) {
          onComplete();
        }
      });
    }
  };
};

const _updateIndicatorTimes = (indicator_prefix, times, creationTime, importTime, dataSource, timeless, validTimes) => {
  return {
    type: ActionTypes.UPDATE_INDICATOR_TIMES,
    indicator_prefix, timeless, times, creationTime, importTime, dataSource, validTimes
  };
};



// WEBPACK FOOTER //
// ./src/actions/update_indicator_times.js